export const QuickLinks = [
  { name: "Home", link: "/" },
  { name: "Shop", link: "/all-products" },
  { name: "Offer", link: "/" },
  { name: "About Us", link: "/about" },
  { name: "Contact Us", link: "/contact" },
];
export const CustomerAreas = [
  { name: "Account", link: "#" },
  { name: "Orders", link: "#" },
  { name: "Wishlist", link: "#" },
  { name: "Ratings & Reviews", link: "#" },
];
export const PopularCategory = [
  { name: "Novel", link: "#" },
  { name: "Poem", link: "#" },
  { name: "Drama", link: "#" },
  { name: "History", link: "#" },
  { name: "Science Fiction", link: "#" },
];
export const SocialMedia = [
  { name: "Facebook", link: "#" },
  { name: "Instagram", link: "#" },
  { name: "WhatsApp", link: "#" },
  { name: "Twitter", link: "#" },
];
